// src/pages/Banks/Banks.jsx
import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import BanksTable from '../../components/banks/BanksTable';

const Banks = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <BanksTable />
        </WrapperSection>
    );
};

export default Banks;
